import {
  IData_UserSummary,
} from '../types/schema/user_summary'

import {
  LAYOUT_CELL_TYPE_BOOKING_DETAILS,
} from '../constants'

/*

  GENERIC HOOKS

  used mainly for "inject some config"

*/
export const genericHooks: Record<string, Record<string, <T = any>(data: T) => T>> = {
  firstthermal: {
    mapLayoutOptions: (data: any) => {
      // we add the "booking details widget" to the first thermal
      // widgets if we are editing an email - this is so they can
      // have easy booking details in the emails
      if(data.name == 'astonish') {
        return Object.assign({}, data, {
          widgets: data.widgets.concat([LAYOUT_CELL_TYPE_BOOKING_DETAILS]),
        })
      }
      return data
    }
  }
}

export const runGenericHook = <T = any>(summary: IData_UserSummary, feature: string, data: T) => {
  const projectName = summary.project_name
  const hooks = genericHooks[projectName]
  if(!hooks) return data
  const hook = hooks[feature]
  if(!hook) return data
  return hook(data)
}

/*

  FEATURE HOOKS

*/
export const featureHooks: Record<string, (summary: IData_UserSummary, feature: string, defaultValue: boolean) => boolean> = {
  firstthermal: (summary, feature, defaultValue) => {
    if(feature == 'show_network_icon') {
      return isTraineeOrET(summary) ? false : defaultValue
    }
    else {
      return defaultValue
    }
  } 
}

/*

  ROLE HOOKS

*/
// allows us to write custom code for each project
// based on the current user having access to a role
// this means we can say for example:
// if the user has persona X then do this logic
// otherwise do that logic
// returns [handled, result]
// if handled is false - then default to the normal role check
export const roleHooks: Record<string, (summary: IData_UserSummary, role: string) => boolean[]> = {
  // if the user is a heatview_surveyor or a trainee
  // then don't let them see the org data
  firstthermal: (summary, role) => {
    if (isTraineeOrET(summary)) {
      if(role == 'rbac:org_viewer') {
        return [true, true]
      }
      else if(role.startsWith('rbac:')) {
        return [true, false]
      }
      else {
        return [false, false]
      }
    }
    else {
      return [false, false]
    }
    
  } 
}

/*

  HOOK UTILS

  these live here otherwise we get an import cycle

*/

// for first thermal project
export const hasPersona = (
  summary: IData_UserSummary | null,
  persona: string,
): boolean => {
  if(!summary) return false
  return summary.personas.find(p => p == persona) ? true : false
}

export const isTrainee = (summary: IData_UserSummary): boolean => hasPersona(summary, 'trainee')
export const isET = (summary: IData_UserSummary): boolean => hasPersona(summary, 'heatview_surveyor')

export const isTraineeOrET = (summary: IData_UserSummary): boolean => {
  return isTrainee(summary) || isET(summary)
}